import Joi from "joi";

export const contact_schema = Joi.object({
  name: Joi.string().required(),
  from: Joi.string().email({ minDomainSegments: 2, tlds: false }).required(),
  //phone : Joi.string().optional(),
  message: Joi.string().required(),
});
